import Vue from 'vue'
import Vuex from 'vuex'
import auth from 'inomph-auth'
import supplierStore from './modules/profile'
import modalModule from 'vue-modal/dist/vue-modal-store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    shopCode: null
  },
  actions: {
    userChanged (context, user) {
      context.dispatch('profile/getSupplier', user)
    }
  }
})

store.registerModule('auth', auth({
  endpoint: `${process.env.API_URL}/auth/token`
}))

store.registerModule('profile', supplierStore(process.env))
store.registerModule('modal', modalModule())

store.dispatch('auth/restore')

export default store



// WEBPACK FOOTER //
// ./src/store/index.js